import { ShopModelCarousal } from "../../../constants/jsonConstant";
import { useState, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import "../../../components/shopItemsView/shopitemview.css";
import { Row, Col, Container } from "react-bootstrap";
import BackArrow from "../../../components/backArrow";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RedoIcon from "@mui/icons-material/Redo";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { SuccessNotify } from "../../../constants/tostify";
import { FailedNotify } from "../../../constants/tostify";
import { useGetFoodItemByIdQuery, useDeleteFoodItemMutation } from "../../../features/shop/shopApiSlice";
import noImagePlaceholder from "../../../assets/images/dummy/no_image_placeholder.png";
import ShareModel from "../../../components/Sharemodel";
import ShareOption from "../../../components/Shareoption";
import Loader from "../../../components/Loader";
import { useSelector } from "react-redux";
import { getAsset } from "../../../helpers/helper";
import moment from "moment";
import { MainModal } from "@/components";
import "./style.css";

const FoodItemsView = () => {
  const { name } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const { id, shopid } = useParams();
  const handleClose = () => setShows(0);
  const [increase, setIncrease] = useState(1);
  const [Itemdata, setItemsData] = useState();
  const [shows, setShows] = useState(false);

  const [deleteFoodItem] = useDeleteFoodItemMutation();
  const { data: foodItemQuery, isLoading: foodItemLoading } = useGetFoodItemByIdQuery(id, { skip: !id });

  useEffect(() => {
    if (foodItemQuery?.data) {
      setItemsData(foodItemQuery?.data);
    }
  }, [foodItemQuery]);

  const Deleteitem = async () => {
    setShows(0);
    setIsloading(true);
    try {
      const response = await deleteFoodItem(id).unwrap();
      if (response.success) {
        setIsloading(false);
        SuccessNotify("Item Deleted Successfully");
        navigate(`/RestaurantAlldata/${Itemdata.shopid}`);
      }
    } catch (e) {
      setIsloading(false);
      FailedNotify("Failed to Delete Try Again!");
    }
  };

  const [showmodal, setShowmodal] = useState(false);
  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);

  const [showshare, setShowshare] = useState(false);
  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };
  const handleShowshare = () => setShowshare(true);

  const ShopModelCarousal =
    Itemdata?.images && Itemdata.images.length > 0
      ? Itemdata.images.map((image, index) => ({
          id: index + 1,
          original: getAsset(image),
          thumbnail: getAsset(image),
        }))
      : [
          {
            id: 1,
            original: noImagePlaceholder,
            thumbnail: noImagePlaceholder,
          },
        ];

  // Custom render function for images
  const renderCustomItem = (item) => {
    return (
      <div className="image-gallery-image">
        <img
          src={item.original}
          alt={item.originalAlt || "Gallery image"}
          crossOrigin="anonymous"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImagePlaceholder;
          }}
        />
      </div>
    );
  };

  // Custom render function for thumbnails
  const renderCustomThumbnail = (item) => {
    return (
      <img
        src={item.thumbnail}
        alt={item.thumbnailAlt || "Thumbnail image"}
        crossOrigin="anonymous"
        className="image-gallery-thumbnail-image"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImagePlaceholder;
        }}
      />
    );
  };

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
        shareurl={window.location.href}
        shopid={shopid}
        shopTitle={Itemdata?.dishname}
        shopDesc={Itemdata?.description}
        shopImage={Itemdata?.images && Itemdata.images.length > 0 ? Itemdata.images[0] : ""}
      />
      {shows === 1 && (
        <MainModal
          variant="deleteModal"
          show={shows}
          title="Profile"
          handleClose={handleClose}
          animation={true}
          handledelete={Deleteitem}
        />
      )}
      <Container className="restaurant-food-item-view">
        <div className="restaurant-food-item-mobile-back d-md-none">
          <BackArrow mystyle="ps-0" />
        </div>
        <div className="screenHeight">
          <div className="ps-5 restaurant-food-item-created-at">
            <h5>{moment(Itemdata?.createdAt).format("DD MMM YYYY, h:mm A")}</h5>

          </div>
          <Row>
            <Col lg="6">
              <div className="row">
                <ImageGallery
                  showPlayButton={false}
                  showFullscreenButton={false}
                  items={ShopModelCarousal}
                  renderItem={renderCustomItem}
                  renderThumbInner={renderCustomThumbnail}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="ps-4 pe-4 pt-4 pb-1 bg-vilot View-Model-Shadow">
                {isloading === true ? (
                  <Loader heightsetting="screenHeight" />
                ) : (
                  <Row className="restaurant-food-item-details-row">
                    <BackArrow mystyle="ps-0 restaurant-food-item-desktop-back d-none d-md-block" />
                    <div className="restaurant-food-item-heading">
                      <h4 className="fw-bold">{Itemdata?.dishname}</h4>
                      <button className="shareItembtn" onClick={handleShow}>
                        Share <RedoIcon className="share_icon_f" />
                      </button>
                    </div>
                    <p className="col-11 fw-lighter restaurant-food-item-description">{Itemdata?.description}</p>
                    <p className="restaurant-food-item-preparation">
                      Preparation Time : {Itemdata?.preparationTime}
                    </p>
                    <div className="restaurant-food-item-price">
                      <h3 className="font-blue">{Itemdata?.price}</h3>
                    </div>
                    <div className="restaurant-food-item-contact">
                      <p className="mb-0">Contact us on</p>
                      <p className="mb-0">{name.email}</p>
                      <p className="mb-0">{Itemdata?.contact}</p>
                    </div>
                    <div className="bg-white quantityBox restaurant-food-item-quantity mt-2 mb-2 pe-2 ps-2 w-25 d-flex align-items-center">
                      <div>
                        <p className="mb-0 pe-1">QTY:</p>
                      </div>
                      <div>
                        <p className="mb-0 pe-1">{increase}</p>
                      </div>
                      <div>
                        <div className="d-flex flex-column align-items-center">
                          <ExpandLessIcon
                            fontSize="small"
                            onClick={() => setIncrease(increase + 1)}
                          />
                          <ExpandMoreIcon
                            fontSize="small"
                            onClick={() => setIncrease(increase - 1)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="restaurant-food-item-actions pt-4 d-flex">
                      <button
                        className="d-flex align-items-center border rounded ps-3 pe-3 pt-1 pb-1 bg-red text-white"
                        onClick={() => setShows(1)}
                      >
                        <DeleteOutlineOutlinedIcon />
                        <span className="ps-1">Delete</span>
                      </button>
                      <button
                        className="d-flex align-items-center border rounded ps-4 pe-4 pt-1 pb-1 bg-blue ms-3 me-3 text-white"
                        onClick={() => navigate(`/resturent-update-form/` + id)}
                      >
                        <CreateOutlinedIcon />
                        <span className="ps-1">Edit</span>
                      </button>
                    </div>
                  </Row>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default FoodItemsView;